import { useQueryWithUserId } from '@northladder/services';
import { IApiError } from '@northladder/utilities';

import { B2B_SERVICE_API } from '../b2bApiClient';
import { IEntQuoteDetailsData } from '../types';

/**
 * Query key for enterprise customer quote details caching.
 */
export const FETCH_ADMIN_QUOTE_DETAILS_QUERY_KEY =
  'enterprise-admin-quotes-details-key';

/**
 * It returns the query for the mock admin quotes requests data.
 */
export function useAdminQuoteDetailsQuery(id: string, type: string = 'admin') {
  /**
   * Cache stale time for the enterprise quote requests details to 30 seconds.
   */
  const CACHE_STALE_TIME = 30000;

  return useQueryWithUserId<IEntQuoteDetailsData, IApiError>({
    queryKey: [FETCH_ADMIN_QUOTE_DETAILS_QUERY_KEY, id, type],
    queryFn: () => B2B_SERVICE_API.fetchAdminQuotesDetails(id, type),
    staleTime: CACHE_STALE_TIME,
  });
}
